<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      center
      width="600px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-form id="form_exportAis" method="post" v-loading="loading">
        <input type="input" name="export_ids" :value="export_ids" />
        <input type="input" name="fields" :value="fields" />
        <input type="input" name="order" :value="order" />
        <input type="input" name="where_student_no" :value="where_student_no" />
        <input type="input" name="where_name" :value="where_name" />
        <input type="input" name="where_programme" :value="where_programme" />
        <input
          type="input"
          name="where_education_status"
          :value="where_education_status"
        />
        <input
          type="input"
          name="where_education_programme"
          :value="where_education_programme"
        />
        <input
          type="input"
          name="where_education_nation"
          :value="where_education_nation"
        />
        <input
          type="input"
          name="where_education_province"
          :value="where_education_province"
        />
        <input
          type="input"
          name="where_education_city"
          :value="where_education_city"
        />
        <input
          type="input"
          name="where_education_school"
          :value="where_education_school"
        />
        <input
          type="input"
          name="where_education_graduation_year"
          :value="where_education_graduation_year"
        />
        <input type="input" name="where_year" :value="where_year" />
        <input
          type="input"
          name="where_graduation_year"
          :value="where_graduation_year"
        />
        <input
          type="input"
          name="where_education_other"
          :value="where_education_other"
        />
        <input
          type="input"
          name="where_mobile_phone"
          :value="where_mobile_phone"
        />
        <input type="input" name="where_wechat" :value="where_wechat" />
        <input
          type="input"
          name="where_origin_place"
          :value="where_origin_place"
        />
        <input
          type="input"
          name="where_alumni_type"
          :value="where_alumni_type"
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      export_ids: "",
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      fields: "",
      order: "",
      where_student_no: "",
      where_name: "",
      where_programme: "",
      where_education_status: "",
      where_education_programme: "",
      where_education_nation: "",
      where_education_province: "",
      where_education_city: "",
      where_education_school: "",
      where_education_graduation_year: "",
      where_year: "",
      where_graduation_year: "",
      where_education_other: "",
      where_mobile_phone: "",
      where_wechat: "",
      where_origin_place: "",
      where_alumni_type: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(
      checkList,
      order,
      where_student_no,
      where_name,
      where_programme,
      where_education_status,
      where_education_programme,
      where_education_nation,
      where_education_province,
      where_education_city,
      where_education_school,
      where_education_graduation_year,
      where_year,
      where_graduation_year,
      where_education_other,
      where_mobile_phone,
      where_wechat,
      where_origin_place,
      where_alumni_type,
      ids
    ) {
      if (ids) {
        this.export_ids = ids;
      } else {
        this.export_ids = "";
      }
      this.changVisible = true;
      this.fields = StrUtils.getEduInfoFields(checkList);
      this.order = order;
      this.where_student_no = where_student_no;
      this.where_name = where_name;
      this.where_programme = StrUtils.replaceFields(where_programme.toString());
      this.where_education_status = StrUtils.replaceFields(
        where_education_status.toString()
      );
      this.where_education_programme = where_education_programme;
      this.where_education_nation = where_education_nation;
      this.where_education_province = where_education_province;
      this.where_education_city = where_education_city;
      this.where_education_school = where_education_school;
      this.where_education_other = where_education_other;
      this.where_education_graduation_year =
        where_education_graduation_year.length == 0
          ? ""
          : where_education_graduation_year[0] +
            "-" +
            where_education_graduation_year[1];
      this.where_year =
        where_year.length == 0 ? "" : where_year[0] + "-" + where_year[1];
      this.where_graduation_year =
        where_graduation_year.length == 0
          ? ""
          : where_graduation_year[0] + "-" + where_graduation_year[1];
      this.where_mobile_phone = where_mobile_phone;
      this.where_wechat = where_wechat;
      this.where_origin_place = where_origin_place;
      if (where_alumni_type != null) {
        this.where_alumni_type = StrUtils.replaceFields(
          where_alumni_type.toString()
        );
      }
      this.$nextTick(() => {
        const from = document.getElementById("form_exportAis");
        from.action =
          URL_PATH + CApi.api_exportAisEducation + "?token=" + this.token;
        from.submit();
        this.close();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
input {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportAisEducationDialog.vue